import styled from "styled-components";
import { FaInstagram, FaGlobe, FaWhatsapp } from "react-icons/fa";
import iconDefault from "../image/logo_reclameaqui.png";
import iconHover from "../image/logo_reclameaquihover.png";

const IconContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
`;

const IconLink = styled.a`
  color: ${({ theme }) => theme.text};
  font-size: 2rem;
  transition: 0.3s;

  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

// const IconImage = styled.img`
//   width: 32px;
//   height: 32px;
//   fill: currentColor;
//   transition: color 0.3s ease;
//   background-image: url(${icon});

//   &:hover {
//     color: #7f13d1ff;
//   }

//   &:hover {
//     fill: #7f13d1ff;
//   }

//   @media screen and (max-width: 768px) {
//     width: 28px;
//     height: 28px;
//   }
// `;

const IconImage = styled.span`
  display: inline-block;
  width: 32px;
  height: 32px;
  background-image: url(${iconDefault});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: background-image 0.3s ease;

  &:hover {
    background-image: url(${iconHover});
  }

  @media screen and (max-width: 768px) {
    width: 28px;
    height: 28px;
  }
`;

export const SocialIcons = () => (
  <IconContainer>
    <IconLink
      href="https://api.whatsapp.com/send/?phone=5579999928569&text=Estou+a+disposi%C3%A7%C3%A3o%21&type=phone_number&app_absent=0"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp />
    </IconLink>

    <IconLink
      href="https://powpix.com.br/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaGlobe />
    </IconLink>
    <IconLink
      href="https://www.instagram.com/usepowpix/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaInstagram />
    </IconLink>

    <IconLink
      href="https://www.reclameaqui.com.br/empresa/powpay-maquininhas-ltda/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <IconImage />
    </IconLink>
  </IconContainer>
);
